"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfActivitySessionDataViewModel = instanceOfActivitySessionDataViewModel;
exports.ActivitySessionDataViewModelFromJSON = ActivitySessionDataViewModelFromJSON;
exports.ActivitySessionDataViewModelFromJSONTyped = ActivitySessionDataViewModelFromJSONTyped;
exports.ActivitySessionDataViewModelToJSON = ActivitySessionDataViewModelToJSON;
exports.ActivitySessionDataViewModelToJSONTyped = ActivitySessionDataViewModelToJSONTyped;
/**
 * Check if a given object implements the ActivitySessionDataViewModel interface.
 */
function instanceOfActivitySessionDataViewModel(value) {
    return true;
}
function ActivitySessionDataViewModelFromJSON(json) {
    return ActivitySessionDataViewModelFromJSONTyped(json, false);
}
function ActivitySessionDataViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
function ActivitySessionDataViewModelToJSON(json) {
    return ActivitySessionDataViewModelToJSONTyped(json, false);
}
function ActivitySessionDataViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'groupName': value['groupName'],
        'active': value['active'],
    };
}
